export default "__VITE_ASSET__CMFl3cRu__"